export default [
    {
        path: '/suspended',
        name: 'Suspended Account',
        component: () => import('@/views/suspended'),
        meta:
        {
            name: 'Account Suspended'
        }
    },
];